/**
 * Created by h.nanev on 6/15/2016.
 */
import React from "react";
import PropTypes from "prop-types";
import documentedProps from "./documentation/ModalFooterDocumentedProps";

const MODAL_CANCEL_CLASS = "ModalCancel";
const MODAL_SUBMIT_CLASS = "ModalSubmit";

export default class ModalFooter extends React.Component {
    constructor(props) {
        super(props);

        this.enhanceChildren = this.enhanceChildren.bind(this);
    }

    enhanceChildren() {
        var result = [];

        React.Children.forEach(this.props.children, (child, index) => {
            if (!React.isValidElement(child)) return;

            const displayName = child.type.displayName || child.type.name;
            if (
                displayName.includes(MODAL_CANCEL_CLASS) ||
                displayName === this.props.modalCancelClass
            ) {
                result.push(
                    React.cloneElement(child, {
                        key: "footer-item-" + index,
                        onModalClose: this.props.onModalClose
                    })
                );
            } else if (
                displayName === MODAL_SUBMIT_CLASS ||
                displayName === this.props.modalSubmitClass
            ) {
                result.push(
                    React.cloneElement(child, {
                        key: "footer-item-" + index,
                        onModalSubmit: this.props.onModalSubmit
                    })
                );
            } else {
                result.push(child);
            }
        });

        return result;
    }

    render() {
        let enhancedChildren = this.enhanceChildren();
        let extraClasses = this.props.extraClasses || "";
        let className = extraClasses + "tq-modal-footer";
        return <footer className={className}>{enhancedChildren}</footer>;
    }
}

ModalFooter.displayName = "ModalFooter";

ModalFooter.propTypes = {
    extraClasses: PropTypes.string,
    onModalClose: PropTypes.func,
    onModalSubmit: PropTypes.func,
    modalCancelClass: PropTypes.string,
    modalSubmitClass: PropTypes.string
};

ModalFooter.documentedProps = documentedProps;
